import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SessionService, HttpService, MessageService, FunctionsService, FileFormsService, TableColumns, TableConfiguration, fileInputParams, params, CombosConfiguration, LocalStorageService } from 'brainloper-ui';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { Disabilities } from 'src/app/models/human-resources/disabilities';
import { User } from 'src/app/models/administration/user';
import { UpdateData } from 'src/app/models/commos/update-data';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { CalculateDurationService } from 'src/app/utils/calculate-duration';
import { BaseResponse } from 'src/app/models/commos/base-response';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { SizePicture } from 'src/app/models/commos/size-pircture';

@Component({
    selector: 'app-disabilities-detail',
    templateUrl: './disabilities-detail.component.html',
    styleUrls: ['./disabilities-detail.component.scss'],
    standalone: false
})
export class DisabilitiesDetailComponent implements OnInit {


  private urlGetDatosArl: string = `${EndpointDictionary.ARL.ARL_COMBO}`
  private urlGetDatosEps: string = `${EndpointDictionary.EPS.EPS_COMBO}`
  public urlGetUsuarios: string = `${EndpointDictionary.User.USER_TABLE}`
  private urlGetUsuariosDetalle: string = `${EndpointDictionary.User.CRUD_USER_DATA}`
  private urlPostIncapacidades: string = `${EndpointDictionary.Disabilities.CRUD_DISABILITIES_DATA}`
  private messagErrorDate = "La fecha final no puede ser inferior a la fecha de inicio"
  public tipoRedireccion: string
  public imageSrc: string
  public movil
  public sizePicture: SizePicture
  public file = null
  public companyId: number
  public nombreSelecionado: string
  public nameFile: string
  public arlLabel: string
  public epsLabel: string

  public userId: number
  public usuario: number
  public fechaLabel: string
  public duration: string
  public inicio: string
  public final: string
  public descripcionLabel: string
  public disabilityTypeLabel: string
  public fileForm: string
  public anexo: string
  private epsId: number
  private arlId: number

  public firtsForm: UntypedFormGroup;
  public FormDisabilities: UntypedFormGroup;

  //file pdf
  public fileInputIncapacidad: fileInputParams = {
    typeFile: "pdf",
    input: "formulario",
    label: "Evidencia en pdf",
    edit: true,
    style: {
      width: '100%'
    }
  }

  //recargarTablaUsuarios = new EventEmitter<any>()
  public configurationUsuarios: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    primaryKey: 'userId'
  }

  public columnasUsuarios: TableColumns<User>[] = [
    {
      ID: 'user',
      label: 'Usuario',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },

    },
    {
      ID: 'name',
      label: 'Nombre',
      type: 'string',
      style: {
        textAlign: 'center'
      },
    }
  ]

  public reloadComboArl = new EventEmitter<any>()
  public combosConfigArl: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'id',
    urlCombo: this.urlGetDatosArl,
    urlParams: [],
    selected: 0,
    label: 'ARL',
  }


  public reloadComboEps = new EventEmitter<any>()
  public combosConfigEps: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'id',
    urlCombo: this.urlGetDatosEps,
    urlParams: [],
    selected: 0,
    label: 'EPS',
  }

  constructor(
    public dialogRef: MatDialogRef<DisabilitiesDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private session: SessionService,
    private formBuilder: UntypedFormBuilder,
    private http: HttpService,
    private message: MessageService,
    private functionEter: FunctionsService,
    private formFile: FileFormsService,
    private calculeDuration: CalculateDurationService,
    private storage: LocalStorageService
  ) {
    this.companyId = this.storage.get<number>('companyId')
    this.firtsForm = this.formBuilder.group({
      selection: ''
    })

    this.FormDisabilities = this.formBuilder.group({
      date: '',
      startDate: '',
      finalDate: '',
      duration: '',
      disabilityType: '',
      description: '',
      disabilityPdf: '',
      eps: '',
      arl: ''
    })
  }

  ngOnInit(): void {

    this.message.openLoading('Cargando', 'Cargando')
    this.tipoRedireccion = this.session.getData('redireccion')
    this.movil = screen.width > 600 ? false : true
    this.FormDisabilities.get('date').setValue(new Date())

    this.sizePicture = {
      'width': `60%`,
      'margin-top': '5%',
      'border': '1px solid black',
    }

    if (this.tipoRedireccion == 'visualizar') {
      this.inicializarCampos()
    }
    if (this.tipoRedireccion == 'nuevo') {
      this.message.closeLoading()
    }


  }

  async inicializarCampos() {

    //console.log("Data",this.data)
    let res: Array<Disabilities> = await this.http.getDataBody(`${this.urlPostIncapacidades}/${this.data.id}`)
    if (res) {
      var data = res[0]
      this.nombreSelecionado = data.userName
      this.usuario = data.user
      this.descripcionLabel = data.description
      this.fechaLabel = this.functionEter.dateIso(data.date)
      this.anexo = `${EndpointDictionary.Base._BASE_URL_V2}${data.disabilityPdf}/${this.companyId}`
      this.inicio = this.functionEter.dateIso(data.startDate)
      this.final = this.functionEter.dateIso(data.finalDate)
      this.duration = data.duration
      this.disabilityTypeLabel = data.disabilityType
      this.arlLabel = data.arl
      this.epsLabel = data.eps
    }

    let response: Array<User> = await this.http.getDataBody(`${this.urlGetUsuariosDetalle}/${data.userId}`)
    if (response) {
      let body = response[0]
      this.imageSrc = `${EndpointDictionary.Base._BASE_URL_V2}${body.photo}/${this.companyId}`
    }
    this.message.closeLoading()
  }

  seleccionadosUsuarios($event) {
    console.log($event)
  }
  clickFilaUsuarios($event: User) {

    this.nombreSelecionado = $event.name
    this.userId = $event.userId
    this.usuario = $event.user
    this.firtsForm.get('selection').setValue($event.name)

    this.http.getData(`${this.urlGetUsuariosDetalle}/${this.userId}`).subscribe(
      (res: BaseResponse<Array<User>>) => {
        if (res['code'] === 0) {
          this.message.closeLoading()
          let dataUser = res['body'][0]
          this.imageSrc = `${EndpointDictionary.Base._BASE_URL_V2}${dataUser.photo}/${this.companyId}`
          this.arlLabel = dataUser.arlName
          this.epsLabel = dataUser.epsName
          this.FormDisabilities.get('eps').setValue(dataUser.epsName)
          this.FormDisabilities.get('arl').setValue(dataUser.arlName)
          this.epsId = dataUser.epsId
          this.arlId = dataUser.arlId

          this.combosConfigEps.selected = dataUser.epsId
          this.reloadComboEps.emit("selected")
          this.combosConfigArl.selected = dataUser.arlId
          this.reloadComboArl.emit("selected")

        } else {
          this.message.closeLoading()
          //console.log('error capturando datos usuario')
        }
      },
      err => {
        this.message.closeLoading()
        console.log(err)
      }
    )

  }

  saveForm(form: Disabilities) {

    this.descripcionLabel = form.description
    this.disabilityTypeLabel = form.disabilityType
    this.fechaLabel = this.functionEter.dateForm(form.date)
  }

  errorMessage() {
    let msg = 'Complete los campos'
    if (this.duration == null) msg = this.messagErrorDate
    this.message.Error('Error', msg)
  }

  async changeDate($event: MatDatepickerInputEvent<Date>, data: string) {
    const fechaFormateada = this.functionEter.dateForm($event.value);

    if (data == 'inicio') {
      this.inicio = fechaFormateada;
    } else {
      this.final = fechaFormateada;
    }

    if (this.inicio && this.final) {
      let inicioDate = new Date(this.inicio);
      let finalDate = new Date(this.final);


      if (finalDate >= inicioDate) {
        this.duration = await this.calculeDuration.calculateDuration(inicioDate, finalDate)
        this.FormDisabilities.get('duration').setValue(this.duration);
      } else {
        this.message.Error("Error", this.messagErrorDate);
        this.duration = null;
        this.FormDisabilities.get('duration').setValue(null);
      }
    }
  }

  fileSaveIncapacidad($event: UpdateData<Disabilities>) {
    this.file = $event.new
    this.nameFile = $event.new.name
    this.fileInputIncapacidad.label = $event.new.name
  }

  async save() {
    if (this.file == null) {
      console.log('no se agrego archivo')
      this.fileForm = ''
    } else {
      let formFile = this.formFile.createMultipartForm(this.file)
      let res: string = await this.http.postDataBody(`${EndpointDictionary.Docs.DOCS_SUBIR}`, formFile)
      this.fileForm = (res)
    }

    let form: Disabilities = {
      userId: this.userId,
      date: this.fechaLabel,
      startDate: this.inicio,
      finalDate: this.final,
      duration: this.duration,
      disabilityType: this.disabilityTypeLabel,
      description: this.descripcionLabel,
      disabilityPdf: this.fileForm,
      epsId: this.epsId,
      arlId: this.arlId,
    }

    //console.log(form)
    this.http.postData(`${this.urlPostIncapacidades}`, form).subscribe(
      (res: BaseResponse<GenericResponse>) => {
        console.log(res)
        if (res['code'] === 0) {
          this.message.SuccessToast('Incapacidad creada correctamente')
          this.dialogRef.close()
        } else {
          this.message.Error('Error', 'Error creando incapacidad')
        }
      }, err => {
        this.message.Error('Error', `${err}`)
      }
    )



  }

  openAnexo() {

    event.preventDefault()

    let ancho: number = 800
    let alto: number = 700
    var x: number = (screen.width / 2) - (ancho / 2);
    var y: number = (screen.height / 2) - (alto / 2);
    window.open(this.anexo, 'popup', 'width=' + ancho + ', height=' + alto + ', left=' + x + ', top=' + y + '')

  }

}
